import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DAY_MS = 86400000;
const MAX_DAYS = 366;

const CustomDateRangePopover = ({ initialRange, onApply, onClose }) => {
  const [range, setRange] = useState([
    {
      startDate: initialRange && initialRange.fromDate != null ? new Date(initialRange.fromDate) : new Date(Date.now() - 7 * DAY_MS),
      endDate: initialRange && initialRange.toDate != null ? new Date(initialRange.toDate) : new Date(),
      key: "selection"
    }
  ]);
  const [focusedRange, setFocusedRange] = useState([0, 0]);
  const ref = useRef(null);

  useEffect(() => {
    const handler = e => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  const minDate = (() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    d.setHours(0, 0, 0, 0);
    return d;
  })();

  const sel = range[0] || {};
  const days = sel.startDate && sel.endDate
    ? Math.round((new Date(sel.endDate).setHours(0, 0, 0, 0) - new Date(sel.startDate).setHours(0, 0, 0, 0)) / DAY_MS) + 1
    : 0;
  const exceedsMax = days > MAX_DAYS;
  const canApply = !!sel.startDate && !!sel.endDate && !exceedsMax;

  const handleApply = () => {
    if (!canApply) return;
    const from = new Date(sel.startDate);
    from.setHours(0, 0, 0, 0);
    const to = new Date(sel.endDate);
    to.setHours(23, 59, 59, 999);
    onApply({ fromDate: from.getTime(), toDate: to.getTime() });
  };

  return (
    <div className="customDatePopover" ref={ref}>
      <DateRange
        editableDateInputs={false}
        onChange={item => {
          const selection = item.selection;
          const isPickingStart = focusedRange[1] === 0;
          const canPreserveEnd = sel.endDate && selection.startDate <= sel.endDate;
          if (isPickingStart && canPreserveEnd) {
            setRange([{ ...selection, endDate: new Date(sel.endDate) }]);
          } else {
            setRange([selection]);
          }
        }}
        onRangeFocusChange={setFocusedRange}
        moveRangeOnFirstSelection={false}
        ranges={range}
        minDate={minDate}
        maxDate={new Date()}
      />
      {exceedsMax && <p className="customDateErr">Date range is limited to 1 year</p>}
      <div className="customDateFooter">
        <button type="button" className="customDateCancelBtn" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="customDateApplyBtn" onClick={handleApply} disabled={!canApply}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default CustomDateRangePopover;
